<template>
  <div>
    <p class="crm-kicker">Stand · Journées du Courtage</p>
    <h1 class="crm-title">Visite rapide</h1>
    <p class="crm-hint">Identifier un courtier en une donnée — ~20 secondes.</p>

    <div class="crm-card">
      <label class="crm-label">Recherche</label>
      <input class="crm-input crm-input-lg" v-model="q" placeholder="Nom, société, email, tél, ORIAS…" @input="onSearch" />
      <div v-if="loading" class="crm-hint" style="margin-top:10px;margin-bottom:0">Recherche…</div>
      <div v-if="error" class="crm-hint danger" style="margin-top:10px;margin-bottom:0">{{ error }}</div>
    </div>

    <div v-if="hits.length" style="margin-bottom:12px">
      <div
        v-for="hit in hits"
        :key="hit.id"
        class="crm-list-row"
        @click="openHit(hit)"
        style="cursor:pointer"
      >
        <div style="flex:1;min-width:0">
          <div class="crm-row-title">{{ display(hit) }}</div>
          <div class="crm-row-meta">{{ hit.societe }} · {{ hit.email || hit.telephone || hit.orias || '—' }}</div>
        </div>
        <span class="crm-badge">{{ hit.relation || hit.source }}</span>
      </div>
    </div>

    <div v-if="searched && !loading && !hits.length" class="crm-card">
      <p class="crm-hint" style="margin:0">Aucun résultat. Créez une fiche minimale.</p>
    </div>

    <div class="crm-btn-stack" style="margin-bottom:12px">
      <button type="button" class="crm-btn crm-btn-primary crm-btn-lg" @click="nouveau">Nouveau contact</button>
    </div>

    <div class="crm-upload">
      <label class="crm-label" style="margin-bottom:0">Photo carte / badge (facultatif)</label>
      <p class="crm-hint" style="margin-bottom:0">
        La photo est jointe au contact à l’enregistrement de la visite. Elle ne remplit pas le formulaire.
      </p>
      <input
        ref="photoInput"
        class="crm-upload-input"
        type="file"
        accept="image/*"
        capture="environment"
        @change="onPhoto"
      />
      <div class="crm-upload-actions">
        <button type="button" class="crm-btn crm-btn-outline crm-btn-lg" @click="pickPhoto">
          {{ photoPreview ? 'Changer la photo' : 'Prendre / choisir une photo' }}
        </button>
      </div>
      <img v-if="photoPreview" :src="photoPreview" class="crm-img-carte" alt="Aperçu carte" />
    </div>
  </div>
</template>

<script>
import { displayName } from './crmSalonUtils'

export default {
  name: 'CrmSalonHome',
  data() {
    return {
      q: this.$route.query.q || '',
      hits: [],
      loading: false,
      searched: false,
      error: '',
      photoPreview: null,
      timer: null
    }
  },
  mounted() {
    if (this.q && this.q.length >= 2) this.search()
  },
  watch: {
    '$route.query.q'(v) {
      if (v && v !== this.q) {
        this.q = v
        this.search()
      }
    }
  },
  methods: {
    display: displayName,
    pickPhoto() {
      this.$refs.photoInput && this.$refs.photoInput.click()
    },
    onSearch() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.search(), 280)
    },
    async search() {
      const q = (this.q || '').trim()
      if (q.length < 2) {
        this.hits = []
        this.searched = false
        return
      }
      this.loading = true
      this.error = ''
      try {
        const { data } = await this.$apollo.query({
          client: 'AUTH',
          query: require('src/graphql/auth/crmSalon/crmSalonSearch.gql'),
          variables: { q },
          fetchPolicy: 'network-only'
        })
        this.hits = data.crmSalonSearch || []
        this.searched = true
      } catch (e) {
        this.error = (e && e.message) || 'Erreur recherche'
        this.hits = []
      } finally {
        this.loading = false
      }
    },
    openHit(hit) {
      this.$router.push({ path: '/crm-salon/visite', query: { id: hit.id } })
    },
    nouveau() {
      this.$router.push({ path: '/crm-salon/visite', query: { new: '1' } })
    },
    onPhoto(e) {
      const file = e.target.files && e.target.files[0]
      this.error = ''
      if (!file) {
        this.photoPreview = null
        sessionStorage.removeItem('crm_salon_photo_dataurl')
        return
      }
      this.photoPreview = URL.createObjectURL(file)
      const reader = new FileReader()
      reader.onload = () => {
        sessionStorage.setItem('crm_salon_photo_dataurl', reader.result)
      }
      reader.readAsDataURL(file)
      if (e.target) e.target.value = ''
    }
  }
}
</script>
